export enum AuthFieldsNames {
  EMAIL = 'email',
  PASSWORD = 'password',
}

export type TLogInFormValues = {
  [AuthFieldsNames.EMAIL]: string;
  [AuthFieldsNames.PASSWORD]: string;
};
